import {
  getBuildTypeHref,
  getFavoriteBuildsHref,
  getPipelineHref,
  getProjectHref,
} from '../../../../../routes'
import type {ProjectsTreeItem} from '../../../../../types/projectTrees'

import type {ProjectSidebarData} from './ProjectsSidebar.slices'
import {projectsSidebar} from './ProjectsSidebar.slices'

export const getBaseHref = (item: ProjectsTreeItem) => {
  switch (item.itemType) {
    case 'project':
      return getProjectHref(item.id, item.group === 'all')

    case 'pipeline':
      return getPipelineHref(item.id)

    case 'buildType':
      return getBuildTypeHref(item.id, item.group === 'all')

    case 'link':
      return getFavoriteBuildsHref()

    default:
      return null
  }
}

const ALL_PROJECTS_COLLAPSED_STORAGE_KEY = 'jb.teamcity.projectsSidebar.allProjectsCollapsed'
export const toProjectsSidebarState = (
  persistentState?: ReturnType<typeof projectsSidebar.getInitialState>,
): ProjectSidebarData => {
  const initialState = projectsSidebar.getInitialState()
  const sessionStorageCollapsedState = window.sessionStorage.getItem(
    ALL_PROJECTS_COLLAPSED_STORAGE_KEY,
  )
  const {
    searchActive,
    searchQuery,
    showArchivedProjects,
    activeItem,
    allProjectsCollapsed: localStorageCollapsedState,
  } = persistentState ?? {}
  const persistedCollapsedState =
    localStorageCollapsedState ??
    (sessionStorageCollapsedState != null ? JSON.parse(sessionStorageCollapsedState) : undefined)

  return {
    searchActive: searchActive ?? initialState.searchActive,
    searchQuery: searchQuery ?? initialState.searchQuery,
    showArchivedProjects: showArchivedProjects ?? initialState.showArchivedProjects,
    activeItem: activeItem ?? initialState.activeItem,
    allProjectsCollapsed: persistedCollapsedState ?? undefined,
  }
}
